import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import Routes from "config/routes";
const useStyles = makeStyles((theme) => ({
  desktopNavActions: {
    display: "flex",
    gap: theme.spacing(1),
  },
}));

const DesktopNavActions = ({ authUser, onSignOut, onFindBooking, onSignUp, onSignIn }) => {
  const classes = useStyles();

  return (
    <div className={classes.desktopNavActions}>
      {authUser ? (
        <>
          <Button variant="text" onClick={onSignOut}>
            Sign Out
          </Button>
          <Button component={Link} to={Routes.ACCOUNT} variant="contained" color="primary">
            My Account
          </Button>
        </>
      ) : (
        <>
          <Button variant="text" onClick={onFindBooking}>
            Manage Booking
          </Button>
          <Button variant="outlined" onClick={onSignUp} color="primary">
            Join Now
          </Button>
          <Button variant="contained" color="primary" onClick={onSignIn}>
            Sign In
          </Button>
        </>
      )}
    </div>
  );
};
DesktopNavActions.propTypes = {
  authUser: PropTypes.object,
  onSignOut: PropTypes.func.isRequired,
  onFindBooking: PropTypes.func.isRequired,
  onSignUp: PropTypes.func.isRequired,
  onSignIn: PropTypes.func.isRequired,
};

export default DesktopNavActions;
